import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "../../../../types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "../../../../services/iconService";

const IconLicencePointsOne = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={{ ...sx }} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <polygon
          points="166.325,94.511 133.675,94.511 133.675,108.113 150.071,108.113 150.071,205.436 166.325,205.436"
        />
        <path
          d="M29.485,287.125c-9.121-0.029-16.556-7.465-16.586-16.575V65.909c0-1.907,1.547-3.454,3.455-3.454
			c1.906,0,3.453,1.546,3.453,3.454V270.54c0.018,5.314,4.363,9.662,9.688,9.679h241.006c5.321-0.013,9.672-4.36,9.688-9.69V29.461
			c-0.018-5.319-4.367-9.666-9.697-9.679H29.496c-5.325,0.018-9.672,4.363-9.688,9.689V42.72c0,1.907-1.547,3.454-3.453,3.454
			c-1.908,0-3.455-1.546-3.455-3.454V29.461c0.03-9.118,7.459-16.551,16.563-16.586c0.008,0,0.017,0,0.022,0h241.018
			c9.126,0.021,16.566,7.458,16.598,16.575V270.54c-0.03,9.129-7.472,16.563-16.588,16.586H29.485z"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.563H33.874c-1.907,0-3.454-1.546-3.454-3.454c0-1.907,1.547-3.454,3.454-3.454H262.67V33.848
			c0-1.907,1.547-3.454,3.454-3.454s3.454,1.546,3.454,3.454v232.261C269.578,268.017,268.03,269.563,266.124,269.563z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsOne;
